export default {
  app: {
    privacy: {
      policy: 'politika e privatësisë',
      expansive: 'Duke përdorur Expansive, ju pranoni {action} të Expansive',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Seanca ka skaduar',
    sessionExpiredDescription:
      'Seanca juaj ka skaduar. Ju lutemi identifikohuni përsëri për të vazhduar përdorimin e aplikacionit.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Zgjidhni gjuhën',
      chooseLanguageDescription:
        'Zgjidhni gjuhën tuaj të preferuar për aplikacionin. Kjo do të ndryshojë gjuhën e ndërfaqes dhe përmbajtjes.',
    },
    userSelection: {
      cancel: 'Anulo',
      createNewUser: 'Emri i tyre nuk është në listë',
      newUser: 'Përdorues i ri',
      selectAnExistingUser: 'Zgjidhni një përdorues ekzistues',
      selectUserHint: 'Zgjidhni një përdorues ekzistues ose krijoni një të ri për të vazhduar.',
      startTypingToSearch: 'Filloni të shkruani...',
    },
    verification: {
      codeVerification: {
        continue: 'Vazhdo',
        header: 'Shkruani kodin e hyrjes në vend',
        invalidCode: 'Kodi i pavlefshëm, ju lutemi provoni përsëri.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Vazhdo pa verifikuar vendndodhjen',
        enterSiteAccessCode: 'Shkruani kodin e hyrjes në vend',
        locationNotEnabledOrAvailable: 'Pse po e shoh këtë?',
        notAvailable: {
          description: 'Vendndodhja GPS nuk mbështetet në këtë pajisje.',
          header: 'Vendndodhja nuk mbështetet',
        },
        notEnabled: {
          description: 'Shërbimet e vendndodhjes nuk janë të aktivizuara ose leja nuk është dhënë.',
          header: 'Vendndodhja nuk është e aktivizuar',
        },
        notVerified: {
          description: 'GPS tregon se nuk jeni në vendngjarje.',
          header: 'Vendndodhja nuk u verifikua',
        },
        tryAgain: 'Provo përsëri',
        unavailable: {
          description: 'Nuk mundëm të verifikojmë vendndodhjen tuaj GPS.',
          header: 'Vendndodhja e padisponueshme',
        },
        unknown: {
          description: 'Nuk mund të përcaktojmë vendndodhjen tuaj.',
          header: 'Vendndodhja e panjohur',
        },
        verified: {
          description: 'GPS tregon se jeni në vendngjarje.',
          header: 'Vendndodhja u verifikua',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Asnjë aset i gjetur',
        emptyDescription: 'Nuk ka asete të lidhura me këtë urdhër pune.',
        warrantyParts: 'Kohëzgjatja e garancisë skadon',
        serialNumber: 'Numri serial',
        none: '<asnjë>',
      },
      updates: {
        emptyTitle: 'Asnjë përditësim i gjetur',
        emptyDescription: 'Nuk ka përditësimesh për këtë urdhër pune.',
        unknownUser: 'Përdorues i panjohur',
        none: 'Asgjë',
        addComment: {
          buttonLabel: 'Shto një koment',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Rreziqet',
          no: 'Jo',
          yes: 'Po',
        },
      },
    },
    attachmentsList: {
      attachments: 'Shtojcat',
      documents: 'Dokumentet',
      siteDocuments: 'Dokumentet e vendit',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Rreziqet',
        induction: 'Hyrje',
        safeToProceed: 'E sigurt për të vazhduar',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Data e afatit',
        activeSessions: 'Seanca aktive',
        activeSessionsDescription:
          'Jeni tashmë të regjistruar në urdhërat e mëposhtëm të punës. Duhet të shkëputeni nga këto urdhra pune para se të regjistroheni në një urdhër të ri pune.',
        resumeSession: 'Vazhdo',
        startTime: 'Filluar në',
        unexpectedErrorTitle: 'Gabim befasues',
        unexpectedErrorMessage:
          'Ndodhi një gabim befasues gjatë përpjekjes për të krijuar seancat tuaja. Ju lutemi provoni përsëri më vonë.',
        engineerNotFound: 'Inxhinieri nuk u gjet',
        engineerNotFoundDescription:
          'Inxhinieri që po përpiqeni të regjistroheni nuk gjendet në sistem. Ju lutemi kontaktoni administratorin tuaj.',
      },
      verification: {
        code: {
          description:
            'Për të u regjistruar, ju lutemi merrni kodin 4-shifror nga menaxheri i vendit ose kontakti i caktuar.',
        },
        geo: {
          continue: 'Vazhdo',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Ju lutemi merrni kodin e aksesit nga menaxheri i vendit ose kontakti i caktuar për të përfunduar vizitën tuaj.',
            checkOut: 'Shkëput',
            completeBeforeLeaving:
              'Ju lutemi plotësoni formularin e mëposhtëm para se të largoheni.',
            continue: 'Vazhdo',
            noResolutionSelected: 'Ju lutemi zgjidhni një zgjidhje para se të vazhdoni.',
            quoteRequired: {
              hint: 'Vizita e përfunduar, oferta do të ndjekë',
              label: 'Kërkohet oferta',
            },
            returnVisitRequired: {
              hint: 'Do të kthehemi përsëri për të përfunduar',
              label: 'Vizitë e kthimit të kërkuar',
            },
            serviceCompleted: {
              hint: 'Nuk kërkohet asnjë veprim tjetër',
              label: 'Shërbimi u përfundua',
            },
            uploadCheckout: 'Ngarko një skedar, foto, ose video',
            visitNotes: 'Shënimet e vizitës',
            workOrderResolution: 'Zgjidhja e urdhrit të punës',
            enterNotes: 'Shkruani ndonjë shënim këtu...',
            errors: {
              timedOut: 'Koha mbaroi, u tejkaluan 30 sekonda. Ju lutem provoni përsëri.',
              closingSession: 'Gabim gjatë mbylljes së seancës',
            },
          },
          success: {
            description:
              'Faleminderit që vizituat {site}. | {site} ende ka 1 urdhër të hapur për vizitë. | {site} ende ka {count} urdhëra të hapur për vizitë.',
            endVisit: 'Mbyll vizitën',
            header: 'Keni përfunduar me sukses shkëputjen',
            viewWorkOrders: 'Regjistrohu në një urdhër tjetër pune',
          },
          verification: {
            code: {
              description:
                'Për të shkëputur, ju lutemi merrni kodin 4-shifror nga menaxheri i vendit ose kontakti i caktuar.',
              continue: 'Vazhdo',
            },
            geo: {
              checkOut: 'Shkëput',
              continue: 'Vazhdo',
            },
          },
        },
        detail: {
          assets: 'Asetet',
          call: 'Telefononi',
          checkOut: 'Shkëput',
          closed: 'E mbyllur',
          details: 'Detajet',
          dueBy: 'Data e afatit',
          manageEngineers: 'Menaxho inxhinierët',
          notAvailable: 'Nuk është e disponueshme',
          pointOfContact: 'Pika e kontaktit',
          siteAccessTimes: 'Koha e aksesit në vend',
          siteAccessInstructions: 'Udhëzimet e aksesit',
          siteAddress: 'Adresa e vendit',
          siteNotes: 'Shënimet e vendit',
          siteTelephone: 'Telefoni i vendit',
          siteLocation: 'Vendndodhja e vendit',
          updates: 'Përditësimet',
          more: 'Më shumë',
          mismatchErrorTitle: 'Gabim në urdhrin e punës',
          mismatchErrorMessage:
            'Urdhri i punës që po përpiqeni të aksesoni nuk përputhet me atë që jeni aktualisht të regjistruar. Ju lutemi kontrolloni urdhrin tuaj të punës dhe provoni përsëri.',
          siteDocuments: 'Dokumentet e vendit',
          validFrom: 'I vlefshëm nga',
          validUntil: 'I vlefshëm deri',
          documentName: 'Emri i dokumentit',
          documentType: 'Lloji i dokumentit',
          attachments: 'Skedarët e urdhrit të punës',
          download: 'Shkarko',
          workDetails: 'Detajet e punës',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Shto inxhinier ndihmës',
            assistantEngineers: 'Inxhinierët ndihmës',
            description: 'Për arsye sigurie, ju lutemi specifikoni emrat e çdo inxhinieri në vend.',
            editMainEngineer: 'Redakto inxhinierin kryesor',
            errors: {
              creatingEngineer: 'Gabim gjatë krijimit të inxhinierit',
              creatingSession: 'Gabim gjatë krijimit të seancës',
            },
            header: 'Inxhinierët në vend',
            mainEngineer: 'Inxhinieri kryesor',
            newAssistantEngineer: 'Shkruani emrin e plotë',
            next: 'Tjetër',
            removeEngineer: 'Hiq inxhinierin',
            selectExistingAssistantEngineer: 'Filloni të shkruani emrin e tij',
          },
          index: {
            description: 'Për arsye sigurie, ju lutemi specifikoni emrat e çdo inxhinieri në vend.',
            errorCreatingEngineer:
              'Gabim gjatë krijimit të inxhinierit, ju lutemi provoni përsëri.',
            header: 'Inxhinierët në vend',
            hintMainEngineer: 'Shkruani emrin e plotë të inxhinierit kryesor',
            newMainEngineer: 'Inxhinieri kryesor i ri',
            next: 'Tjetër',
            selectExistingMainEngineer: 'Zgjidhni një inxhinier kryesor ekzistues',
            yes: 'Po',
            no: 'Jo',
            mainEngineerLabel: 'A jeni ju inxhinieri kryesor?',
          },
        },
        index: {
          callUsOn: 'Na telefononi në {phoneNumber}',
          description: 'Nuk po gjeni atë që po kërkoni?',
          dueBy: 'Data e afatit',
          header: 'Zgjidhni urdhrin e punës',
          notAvailable: 'Nuk është e disponueshme',
          searchWorkOrders: 'Kërko urdhërat e punës...',
        },
        manageEngineers: {
          manageEngineers: 'Menaxho inxhinierët',
          notWorking: 'Punonjës jo aktivë',
          pause: 'Pauzë',
          resume: 'Vazhdo',
          workingNow: 'Punonjës aktivë',
          startTime: 'Koha e fillimit',
          endTime: 'Koha e përfundimit',
          duration: 'Kohëzgjatja',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Përgjigje',
            feedbackDescription:
              'Ju lutemi jepni përgjigje mbi urdhrin e punës për të na ndihmuar të përmirësojmë shërbimet tona.',
            feedbackLabel: 'Përgjigje',
            filesLabel: 'Shtojcat',
            submissionLabel: 'Dërgo përgjigjen',
          },
          hazards: {
            back: 'Kthehu mbrapa',
            hazards: 'Rreziqet',
            next: 'Tjetër',
            no: 'Jo',
            noTasksForHazard: 'Nuk ka detyra për të përfunduar për këtë rrezik.',
            yes: 'Po',
          },
          induction: {
            continue: 'Vazhdo',
            induction: 'Hyrje',
          },
          index: {
            checkIn: 'Regjistrohu',
            description: 'Ju lutemi plotësoni vlerësimin e rrezikut për punën e zgjedhur.',
            fail: 'Dështoi përpunimi i kontrollit të urdhrit të punës fillestar.',
            haltMessage:
              'Rreziqe të mundshme janë zbuluar. Ju lutemi ndaloni punën, rishikoni udhëzimet për sigurinë, dhe kontaktoni supervizorin tuaj për udhëzime të mëtejshme.',
            header: 'Kontrollet para fillimit të punës',
            endVisit: 'Mbyll vizitën',
            leaveFeedback: 'Lini përgjigje',
          },
          safeToProceed: {
            continue: 'Vazhdo',
            safeToProceed: 'E sigurt për të vazhduar',
          },
        },
      },
    },
    index: {
      title: 'Mirësevini',
      description: 'Skano kodin QR në vendndodhjen tuaj për të filluar.',
    },
    login: {
      errorTitle: 'Gabim befasues',
      errorMessage: 'Ndodhi një gabim befasues. Ju lutemi provoni përsëri skanimin e kodit QR.',
    },
    unauthenticated: {
      welcome: {
        title: 'Mirësevini në {site}',
        description:
          'Para se të mund të ju tregojmë ndonjë urdhër pune, na nevojitet të verifikojmë të dhënat tuaja. Klikoni butonin më poshtë për të vazhduar.',
        next: 'Vazhdo',
      },
      index: {
        errorTitle: 'Gabim befasues',
        errorMessage: 'Ndodhi një gabim befasues. Ju lutemi provoni përsëri skanimin e kodit QR.',
      },
      contractor: {
        title: 'Për kë punoni?',
        contractor: 'Kontraktori',
        contractorLabel: 'Filloni të shkruani emrin e kompanisë suaj',
        contractorHint: 'Duhet të shkruani 3 karaktere ose më shumë për të parë rezultatet',
        defaultSelectPlaceholder: '--Ju lutemi zgjidhni--',
        next: 'Tjetër',
      },
      user: {
        title: 'Kush jeni ju?',
        cancel: 'Anulo',
        createNewUserLabel: 'Emri im nuk është në listë',
        existingUserLabel: 'Filloni të shkruani emrin tuaj',
        existingUserHint: 'Duhet të shkruani 3 karaktere ose më shumë për të parë rezultatet',
        newUserLabel: 'Shkruani emrin tuaj të plotë',
        next: 'Tjetër',
        user: 'Përdorues',
      },
      verification: {
        methods: {
          add: {
            add: 'Shto metodën e verifikimit',
            defaultSelectPlaceholder: '--Ju lutemi zgjidhni--',
            emailLabel: 'Email',
            existingMethodWarning:
              'Keni tashmë një kërkesë në pritje për këtë metodë verifikimi që pret miratimin nga admini. Shtimi i një të re do ta zëvendësojë atë.',
            method: 'Metoda',
            methodLabel: 'Metoda',
            mobileCountryHint: 'Ju lutemi zgjidhni kodin e vendit tuaj',
            mobileCountryLabel: 'Kodi i vendit të celularit',
            mobileHint: 'Ju lutemi shkruani numrin tuaj të celularit',
            mobileLabel: 'Celulari',
            title: 'Shto metodën e verifikimit',
          },
          confirm: {
            confirm: 'Konfirmo',
            description: 'Ju lutemi konfirmoni metodën tuaj të verifikimit për të vazhduar.',
            label: 'Shkruani kodin tuaj',
            resend: 'Risënd',
            resendPrompt: 'Nuk e reçetë një kod?',
            title: 'Konfirmoni Metodën e Verifikimit',
          },
          confirmed: {
            description:
              'Do të njoftoheni një herë që kjo metodë verifikimi është miratuar nga admini juaj, dhe atëherë mund të filloni ta përdorni për të verifikuar identitetin tuaj.',
            forceApproval: 'Derisa të miratohet, nuk jeni në gjendje të aksesoni urdhrat e punës.',
            nonForceApproval:
              'Në ndërkohë, mund të vazhdoni të aksesoni urdhrat e punës me akses të reduktuar.',
            nonForceApprovalButtonLabel: 'Vazhdoni me akses të reduktuar',
            title: 'Në pritje të miratimit',
          },
          addNew: 'Shto metodë të re verifikimi',
          description:
            "Na nevojitet të verifikojmë identitetin tuaj në mënyrë që t'ju japim akses të plotë në urdhrin e punës.",
          email: 'Email',
          hint: 'Ne do të dërgojmë një lidhje në metodën tuaj të zgjedhur të verifikimit e cila ju jep akses të plotë në urdhrin e punës. Nëse keni nevojë të ndryshoni ndonjë metodë ekzistuese të verifikimit, ju lutemi kontaktoni administratorin tuaj.',
          label: 'Zgjidhni një metodë verifikimi',
          next: 'Tjetër',
          pendingHint: 'Në pritje të miratimit nga admini juaj',
          sms: 'SMS',
          title: 'Verifikimi',
        },
        optional: {
          hint: "Verifikimi i të dhënave tuaja të përdoruesit do t'ju japë akses të plotë në urdhrin e punës",
          label: 'A dëshironi të verifikoni të dhënat tuaja të përdoruesit?',
          next: 'Tjetër',
          no: 'Jo',
          noHint:
            'Nuk dua të verifikoj të dhënat e mia të përdoruesit dhe të vazhdoj me akses të reduktuar në urdhrin e punës',
          title: 'Verifikimi',
          yes: 'Po',
          yesHint:
            'Dua të verifikoj të dhënat e mia të përdoruesit dhe të marr akses të plotë në urdhrin e punës',
        },
        sent: {
          description:
            'Një lidhje hyrjeje është dërguar në {identifier}. Ju lutemi klikoni në lidhjen për të përfunduar hyrjen tuaj.',
          title: 'Lidhja e hyrjes është dërguar',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Dje',
      today: 'Sot',
      days: {
        monday: 'E hënë',
        tuesday: 'E martë',
        wednesday: 'E mërkurë',
        thursday: 'E enjte',
        friday: 'E premte',
        saturday: 'E shtunë',
        sunday: 'E diel',
      },
      months: {
        january: 'Janar',
        february: 'Shkurt',
        march: 'Mars',
        april: 'Prill',
        may: 'Maj',
        june: 'Qershor',
        july: 'Korrik',
        august: 'Gusht',
        september: 'Shtator',
        october: 'Tetor',
        november: 'Nëntor',
        december: 'Dhjetor',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Diçka shkoi keq',
      message: 'Ju lutemi provoni përsëri skanimin e kodit QR.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Përdorues i panjohur',
      },
      none: 'Asgjë',
      types: {
        stateTransition: 'Statusi u ndryshua',
        contractorAssigned: 'Kontraktori u caktua',
        engineerAssigned: 'Inxhinieri u caktua',
        serviceAssigned: 'Shërbimi u caktua',
        priorityChanged: 'Prioriteti u ndryshua',
        actionableDateChanged: 'Data e veprimit u ndryshua',
        dueDateChanged: 'Data e skadencës u ndryshua',
        etaDateChanged: 'Data e ardhjes së parashikuar u ndryshua',
        spendLimitApproved: 'Limiti i shpenzimeve u miratua',
        spendLimitCancelled: 'Kërkesa për limit shpenzimesh u anulua',
        spendLimitRejected: 'Limiti i shpenzimeve u refuzua',
        spendLimitRequested: 'Kërkesa për limit shpenzimesh',
        jobSheetUploaded: 'Fletë pune u ngarkua',
        slaAlertSent: 'Koha për të ndihmuar ka kaluar afatin e SLA',
        issuedWorkPermit: 'Leja e punës u lëshua',
        requestForServiceSent: 'Kërkesa për shërbim u dërgua',
        comment: 'Koment u shtua',
        unknown: 'Ngjarje e panjohur',
      },
      labels: {
        actionableDate: 'Data e veprimit',
        comment: 'Koment',
        file: 'Skedari',
        contractor: 'Kontraktori',
        dueDate: 'Data e skadencës',
        etaDate: 'Data e ardhjes së parashikuar',
        engineer: 'Inxhinieri',
        priority: 'Prioriteti',
        requestForService: 'Kërkesa për shërbim',
        service: 'Shërbimi',
        spendLimit: 'Limiti i shpenzimeve',
        status: 'Statusi',
        workPermit: 'Leja e punës',
      },
    },
  },
}
